import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Grid, Box } from "@mui/material";
import WorkPeriod from "../../assets/images/gridmenu/work-period.png";
import Pos from "../../assets/images/gridmenu/pos.png";
import Ticket from "../../assets/images/gridmenu/ticket.png";
import Report from "../../assets/images/gridmenu/report.png";
import Warehouse from "../../assets/images/gridmenu/warehouse.png";
import AdminManage from "../../assets/images/gridmenu/admin-manage.png";
import WorkPeriod2 from "../../assets/images/gridmenu/work-period2.png";
import Logout from "../../assets/images/gridmenu/logout.png";
import KitchenDisplay from "../../assets/images/gridmenu/kitchen-display.png";

const menuInfo = [
  {
    icon: WorkPeriod,
    title: "Work Period",
    color: "#3BB574",
    link: "/work-periods",
  },
  { icon: Pos, title: "POS", color: "#AB32B1", link: "/pos" },
  { icon: Ticket, title: "Tickets", color: "#10B9B3", link: "/tickets" },
  { icon: Report, title: "Reports", color: "#A91120", link: "/reports" },
  {
    icon: Warehouse,
    title: "Warehouse",
    color: "#A0B100",
    link: "/ware-house",
  },
  {
    icon: AdminManage,
    title: "Admin Manage",
    color: "#00364E",
    link: "/admin-manage",
  },
  {
    icon: WorkPeriod2,
    title: "Work Period",
    color: "#333C4B",
    link: "/work-period",
  },
  { icon: Logout, title: "Logout", color: "#ED1B24", link: "/" },
  {
    icon: KitchenDisplay,
    title: "Kitchen Display",
    color: "#0E5A41",
    link: "/kitchen-display",
  },
];

const NineGridMenu = () => {
  const navigate = useNavigate();
  const clickHandle = (value) => {
    navigate(value);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        background: "#C4C4C4",
        paddingBottom: 9,
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="center"
        style={{ width: 1200 }}
      >
        {menuInfo.map((info, idx) => (
          <Grid
            item
            xs={4}
            key={idx}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MenuBox info={info} clickHandle={clickHandle} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const MenuBox = ({ info, clickHandle }) => (
  //   <Link to={info.link}>
  <div
    style={{
      width: 390,
      height: 279,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 9,
      background: "white",
      cursor: "pointer",
    }}
    onClick={() => clickHandle(info.link)}
  >
    <MenuIcon info={info} />
    <div style={{ marginTop: 20, fontSize: 25, color: info.color }}>
      {info.title}
    </div>
  </div>
  //   </Link>
);

const MenuIcon = ({ info }) => (
  <div
    style={{
      width: 116,
      height: 116,
      border: `1px solid ${info.color}`,
      borderRadius: 75,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Avatar
      sx={{
        width: "70px",
        height: "70px",
      }}
      variant="square"
      src={info.icon}
    />
  </div>
);

export default NineGridMenu;
